// MascotContext — provides the active child's mascot variant id to any
// component below the provider.
//
// Why this exists: pre-context, App.jsx threaded `mascotId={progress.mascot?.id}`
// through 8+ screen routes, and several screens (StoryReader, Session) had
// to relay it to inner components like CompletionScreen / FeedbackOverlay.
// Each prop drilling was a place to forget.
//
// Caller pattern (App):
//   <MascotProvider id={progress.mascot?.id || null}>
//     <SessionScreen ... />
//   </MascotProvider>
//
// For one-off cases that need a *specific* mascot regardless of the active
// child — e.g. the picker preview tile, where each tile renders its own
// candidate — consumers pass `variantId` directly.

import { createContext } from "react";

const MascotContext = createContext(null);

export function MascotProvider({ id = null, children }) {
  return <MascotContext.Provider value={id}>{children}</MascotContext.Provider>;
}
